<template>
  <div class="c-t-default">
    <site-header></site-header>
    <transition name="o-transition--fade" mode="out-in">
      <div v-if="!isLoading && !error && post != null" key="content">
        <page-article
          :image="post.acf.featured_image"
          :title="post.title.rendered"
          :body="post.content.rendered"
        ></page-article>
        <sections-wrapper v-if="post.acf.sections !== false" :sections="post.acf.sections"></sections-wrapper>
      </div>
      <div v-else-if="!isLoading && error" key="error">
        <error-state></error-state>
      </div>
      <div v-else key="loading">
        <loader class="c-m-loader--x-large"></loader>
      </div>
    </transition>
    <site-footer></site-footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  FETCH_CONTENT_BY_SLUG,
  GET_CONTENT,
  IS_LOADING,
  GET_ERROR,
} from "../store/store-models/content-model";

import SiteHeader from "./components/organisms/OrganismSiteHeader.vue";
import Loader from "./components/molecules/MoleculeLoader.vue";
import ErrorState from "./components/molecules/MoleculeErrorState.vue";
import PageArticle from "./components/organisms/OrganismArticle.vue";
import SiteFooter from "./components/organisms/OrganismSiteFooter.vue";
import SectionsWrapper from "./SectionsWrapper.vue";

import filters from "../filters/index.js";

export default {
  async asyncData({ store, route }) {
    const { slug } = route.params;
    return store.dispatch(FETCH_CONTENT_BY_SLUG, slug);
  },
  components: {
    SiteHeader,
    Loader,
    ErrorState,
    PageArticle,
    SiteFooter,
    SectionsWrapper
  },
  filters: filters,
  computed: {
    ...mapGetters({
      post: GET_CONTENT,
      isLoading: IS_LOADING,
      error: GET_ERROR
    }),
    metaTitle: function() {
      if (!this.isLoading && !this.error && this.post != null) {
         if (this.post.bb_seo_title !==""){
            return this.post.bb_seo_title;
         }
         return this.post.title.rendered;
      } else if (this.isLoading && !this.error) {
        return "Laddar...";
      } else if (!this.isLoading && this.error) {
        return "Fel";
      }
    },
    metaExcerpt: function() {
      if (!this.isLoading && !this.error && this.post != null) {
          if (this.post.bb_seo_title !==""){
              return this.post.bb_seo_desc;
          }
        return filters.stripHTML(this.post.excerpt.rendered);
      } else if (this.isLoading && !this.error) {
        return "Laddar...";
      } else if (!this.isLoading && this.error) {
        return "Fel";
      }
    }
  },
  methods: {
    ...mapActions({
      fetchContent: FETCH_CONTENT_BY_SLUG
    })
  },

  // * * *
  // We need to use navigation guards (`beforeRoute*`) instead of the usual `created()` in this component as we need to do some hacky sh*t to get anchor links to work. Sorry about that :(
  // * * *

  beforeRouteEnter(to, from, next) {
    let slug = to.params.slug;
    let hash = to.hash;

    next(async vm => {
      // Anchors aweigh! Let's help the browser get us to our target
      if (hash) {
        let target = document.querySelector(hash);
        target.scrollIntoView();
        history.replaceState(null, "", to.fullPath);
      }
    });
  },
  async beforeRouteUpdate(to, from, next) {
    let slug = to.params.slug;

    if (to.hash && to.params.slug === this.$route.params.slug) {
      // This means that we have an anchor link (hash) and that we shouldn't really do anything. Let the browser do its thing.
    } else {
      await this.fetchContent(slug);
      next();
    }
  },
  metaData() {
    return {
      title: this.metaTitle,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.metaExcerpt
        }
      ],
      link: [
        {
          rel: "canonical",
          href: `${process.env.SITE_BASE_URL}${this.$route.path}`
        }
      ]
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Info.vue